(function () {
  if (customElements.get('cart-perks')) return;

  function readConfig() {
    var el = document.getElementById('CartPerksConfig');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // "YYYY-MM-DD HH:MM" in a named time zone (handles Egypt's summer/winter time) -> UTC ms
  function zonedToUtc(str, tz) {
    var m = String(str || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    function offset(t) {
      try {
        var p = {};
        new Intl.DateTimeFormat('en-US', {
          timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
        return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second) - t;
      } catch (e) { return 3 * 3600000; }
    }
    var t = guess - offset(guess);
    return guess - offset(t);
  }

  var lastPct = 0;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  var TEMPLATE =
    '<div class="cart-perks__timer" hidden>' +
      '<span class="cart-perks__timer-label" data-timer-label></span>' +
      '<span class="cart-perks__clock">' +
        '<span class="cart-perks__unit" data-unit="d"><b>00</b><small>d</small></span>' +
        '<span class="cart-perks__unit"><b data-h>00</b><small>h</small></span>' +
        '<span class="cart-perks__unit"><b data-m>00</b><small>m</small></span>' +
        '<span class="cart-perks__unit"><b data-s>00</b><small>s</small></span>' +
      '</span>' +
    '</div>' +
    '<div class="cart-perks__shipping" hidden>' +
      '<p class="cart-perks__msg"><svg class="cart-perks__check" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
        '<path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span data-msg aria-live="polite"></span></p>' +
      '<div class="cart-perks__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="Free shipping progress">' +
        '<span class="cart-perks__fill"></span></div>' +
    '</div>';

  // The drawer's own "Estimated total" is rendered by Shopify from cart.total_price on every update.
  function readDrawerTotal() {
    var el = document.querySelector('#CartDrawer .totals__total-value');
    if (!el) return null;
    var num = el.textContent.replace(/[^0-9.]/g, '');
    if (!num) return null;
    return Math.round(parseFloat(num) * 100);
  }

  class CartPerks extends HTMLElement {
    connectedCallback() {
      this.cfg = readConfig();
      if (!this.cfg) return;
      this.innerHTML = TEMPLATE;
      this.classList.add('cart-perks');
      this.total = readDrawerTotal();
      if (this.total === null) { this.total = 0; this.refresh(); }
      this.timerRow = this.querySelector('.cart-perks__timer');
      this.shipRow = this.querySelector('.cart-perks__shipping');
      this.renderShipping();
      this.startTimer();
      this.updateVisibility();
      // Safety net: some cart updates only refresh part of the drawer, so re-read the real cart total.
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.refresh.bind(this));
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      if (this.unsubscribe) this.unsubscribe();
    }

    refresh() {
      var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((cart) => {
          if (!this.isConnected) return;
          this.total = cart.total_price;
          this.renderShipping();
          this.updateVisibility();
        })
        .catch(function () {});
    }

    sync() {
      var t = readDrawerTotal();
      if (t === null) { this.refresh(); return; }
      if (t !== this.total) { this.total = t; this.renderShipping(); this.updateVisibility(); }
    }

    money(cents) {
      return Math.ceil(cents / 100).toLocaleString('en-US') + ' ' + (this.cfg.currency || 'EGP');
    }

    renderShipping() {
      var c = this.cfg;
      var threshold = Math.round(parseFloat(c.threshold) * 100) || 0;
      if (!c.shipping_enable || threshold <= 0) { this.shipRow.hidden = true; return; }
      this.shipRow.hidden = false;
      var remaining = Math.max(threshold - this.total, 0);
      var pct = Math.min(this.total / threshold, 1) * 100;
      var unlocked = remaining === 0;
      this.classList.toggle('is-unlocked', unlocked);

      var msgEl = this.querySelector('[data-msg]');
      msgEl.textContent = '';
      if (unlocked) {
        msgEl.textContent = c.done || "You've unlocked free shipping";
      } else {
        var parts = String(c.msg || "You're [amount] away from free shipping").split('[amount]');
        parts.forEach((part, i) => {
          if (i > 0) {
            var strong = document.createElement('strong');
            strong.textContent = this.money(remaining);
            msgEl.appendChild(strong);
          }
          msgEl.appendChild(document.createTextNode(part));
        });
      }
      var track = this.querySelector('.cart-perks__track');
      track.setAttribute('aria-valuenow', Math.round(pct));
      var fill = this.querySelector('.cart-perks__fill');
      if (!fill.style.width) {
        // new render of the drawer: start from where the bar was, then animate to the new value
        fill.style.transition = 'none';
        fill.style.width = lastPct + '%';
        void fill.offsetWidth;
        fill.style.transition = '';
      }
      lastPct = pct;
      setTimeout(function () { fill.style.width = pct + '%'; }, 30);
    }

    startTimer() {
      var c = this.cfg;
      this.end = c.timer_enable && c.timer_end ? zonedToUtc(c.timer_end, c.timezone || 'Africa/Cairo') : NaN;
      if (isNaN(this.end)) { this.timerRow.hidden = true; return; }
      this.querySelector('[data-timer-label]').textContent = c.timer_label || '';
      var dUnit = this.querySelector('[data-unit="d"]');
      var tick = () => {
        var s = Math.floor((this.end - Date.now()) / 1000);
        if (s <= 0) {
          this.timerRow.hidden = true;
          clearInterval(this.interval);
          this.updateVisibility();
          return;
        }
        var d = Math.floor(s / 86400);
        dUnit.hidden = d === 0;
        dUnit.querySelector('b').textContent = pad(d);
        this.querySelector('[data-h]').textContent = pad(Math.floor((s % 86400) / 3600));
        this.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
        this.querySelector('[data-s]').textContent = pad(s % 60);
        this.timerRow.hidden = false;
      };
      tick();
      this.interval = setInterval(tick, 1000);
    }

    updateVisibility() {
      this.hidden = this.timerRow.hidden && this.shipRow.hidden;
    }
  }


  customElements.define('cart-perks', CartPerks);

  // Place the box right under the drawer header, and keep it there whenever Dawn re-renders the drawer.
  function ensure() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var header = drawer.querySelector('.drawer__header');
    var existing = drawer.querySelector('cart-perks');
    var empty = drawer.classList.contains('is-empty') || !drawer.querySelector('#CartDrawer .totals__total-value');
    if (empty || !header) { if (existing) existing.remove(); return; }
    if (!existing) {
      header.insertAdjacentElement('afterend', document.createElement('cart-perks'));
    } else {
      if (existing.previousElementSibling !== header) header.insertAdjacentElement('afterend', existing);
      if (existing.sync) existing.sync();
    }
  }

  function init() {
    if (!readConfig()) return;
    var root = document.getElementById('CartDrawer');
    if (!root) return;
    ensure();
    var queued = false;
    new MutationObserver(function (records) {
      var relevant = records.some(function (r) {
        var t = r.target.nodeType === 1 ? r.target : r.target.parentElement;
        return !(t && t.closest && t.closest('cart-perks'));
      });
      if (!relevant || queued) return;
      queued = true;
      setTimeout(function () { queued = false; ensure(); }, 0);
    }).observe(document.querySelector('cart-drawer') || root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
